import { Component, inject, Input } from '@angular/core';
import { NavbarComponent } from "../../../shared/navbar/navbar.component";
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { routeAnimations } from './animation';
import { ChildrenOutletContexts } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationService } from '../../../shared/navbar/navigation.service';
import { LoaderComponent } from "../../../shared/loader/loader.component";
import { SiteFooterComponent } from "../../../shared/site-footer/site-footer.component";
@Component({
  selector: 'horizontal-layout',
  standalone: true,
  imports: [CommonModule, NavbarComponent, RouterOutlet, MatSidenavModule, LoaderComponent, SiteFooterComponent],
  templateUrl: './horizontal.component.html',
  styleUrl: './horizontal.component.scss',
  animations: [routeAnimations],
})
export class HorizontalLayout {
  private contexts = inject(ChildrenOutletContexts);
  private platformId = inject(PLATFORM_ID);
  navData
  @Input() isLoading: boolean = true
  constructor(private navigationService: NavigationService, private router: Router) {
    this.navData = this.navigationService.navData;
  }
  getRouteAnimationData() {
    return isPlatformBrowser(this.platformId)
      ? this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation']
      : null;
  }
  navigateTo(routes: any): void {
    this.router.navigate([routes]);
    // this.router.navigateByUrl(`/`).then(() => {
    // });
  }
}
